export const CONTROL_TYPES = {
    ACL: 'acl',
    BRANCH: 'branch',
    CHECK_BOX_LIST: 'checkboxlist',
    COMPLEX: 'complex',
    CONTACT: 'contact',
    COSTS: 'costs',
    DATE_TIME: 'datetime',
    FEE: 'fee',
    FILES: 'files',
    HIDDEN: 'hidden',
    LIST: 'list',
    MEMBERSHIP: 'membership',
    PASS_ALERT_FAIL: 'passalertfail',
    REG_LOOKUP: 'reglookup',
    RICH_TEXT: 'richtext',
    SELECT: 'select',
    SELECT_CONTACT: 'selectcontact',
    SPLAT: 'splat',
    TEXT: 'text',
    TEXTAREA: 'textarea',
    TOGGLE: 'toggle',
    USERLIST: 'userlist'
};



// WEBPACK FOOTER //
// ./src/vas/controls/control-types.ts